// extracted by mini-css-extract-plugin
var _1 = "webpack-containers-Export-RevmanWebExport-RevmanWebExport-module__header";
export { _1 as "header" }
